<template>
  <!-- DR报告 -->
  <div :style="{'width': width}" v-if="model && model.drReport">
    <div id="print_drReport" class="page drReport-page">
      <div style="height: 50px;"></div>
      <div style="font-size: 22px;"><span>{{ model.drReport.hospitalName ? model.drReport.hospitalName : ""}}</span></div>
      <div style="font-size: 17px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.drReport.reportName ? model.drReport.reportName : "DR检查报告单" }}</span></div>

      <table style="margin-top: 30px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:2px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;width: 70%;"><span style="font-weight: bold;">检查号：</span><span>{{ model.drReport.barCode ? model.drReport.barCode : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">报告时间：</span><span>{{ model.drReport.reportTime ? model.drReport.reportTime : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 5px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:2px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">姓名：</span><span>{{ model.drReport.name ? model.drReport.name : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">性别：</span><span>{{ model.drReport.sex ? model.drReport.sex : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">年龄：</span><span>{{ model.drReport.age ? model.drReport.age : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">检查日期：</span><span>{{ model.drReport.physicalTime ? model.drReport.physicalTime : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td colspan="4" style="border-collapse: collapse;border:none;"><span style="font-weight: bold;">检查部位：</span><span>{{ model.drReport.checkpoint ? model.drReport.checkpoint : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 10px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="height: 200px;border:none;">
            <td style="border-collapse: collapse;border:none;"><img style="width:300px;height:250px" :src="model.drReport.imageUrl"></td>
          </tr>
          <tr style="height: 30px;"></tr>
          <tr style="text-align:left;border:none;">
            <td style="border-collapse: collapse;border:none;">
              <div style="min-height: 200px;padding-bottom: 20px;">
                <p style="font-weight: bold;">影像所见：</p>
                <p v-html="replaceString(model.drReport.modsee, '\n', '<br>')"></p>
              </div>
            </td>
          </tr>
          <tr style="text-align:left;border:none;">
            <td style="border-collapse: collapse;border:none;">
              <div style="min-height: 200px;padding-bottom: 20px;">
                <p style="font-weight: bold;">诊断意见：</p>
                <p v-html="replaceString(model.drReport.moddia, '\n', '<br>')"></p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table style="margin-top: 30px;text-align: left;width: 100%;border-collapse: collapse;border:none;border-bottom:3px solid rgb(14, 14, 14);">
        <tbody>
          <tr style="width: 100%;border-collapse: collapse;text-align: left;border:none;line-height: 30px;">
            <td style="width: 80%;border-collapse: collapse;border:none;">报告医生：<span>{{ model.drReport.reportDoctor ? model.drReport.reportDoctor : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">签字：<img :src="model.drReport.doctorSignature" style="height: 40px;width: 100px;object-fit: contain;" v-if="model.drReport.doctorSignature"></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border:none;" >
        <tbody>
          <tr style="border:none;line-height: 30px;"><td style="text-indent: 2ch;border-collapse: collapse;border:none;">- 备注：本报告仅供临床医师参考，不作任何证明材料。 -</td></tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import {_drReport} from "@/services/report/report";
export default {
  name: "drReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    width: {
      type: [String],
      default: () => {
        return "210mm"
      }
    },
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        drReport:{

        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'drReport'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'drReport') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods:{
    loadData(){
      if(this.barCode){
        this.drReport(this.barCode);
      }
    },
    replaceString(string, key, value) {
      let str = string;
      if(str){
        while (str.indexOf(key) !== -1) {
          str = str.replace(key, value);
        }
      }
      return str;
    },
    drReport(barCode) {
      _drReport({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
}
</script>
<style lang="postcss" scoped>
@media print {
  .drReport-page {
    page: drReport-page; /* 绑定唯一命名 */
  }
  @page drReport-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:40px;padding-right:40px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
